const headerIcon = document.querySelector('.header__icon > a');
const socialsIcons = document.querySelectorAll('#menu-menu-reseaux > li > a');

headerIcon.textContent = '';
socialsIcons.forEach((icon) => {
  icon.textContent = '';
});

const testimonySwiper = new Swiper('#testimony-swiper', {
  slidesPerView: 1,
  effect: 'fade',

  navigation: {
    nextEl: '#testimony-swiper-right',
    prevEl: '#testimony-swiper-left',
  },

  autoplay: {
    delay: 5000,
    disableOnInteraction: true,
  },
});

const rellax = new Rellax('.deco', {
  speed: 1,
  center: true,
});
